



















































































import Vue from 'vue'
import Component from 'vue-class-component'
import Checkbox from '@/components/inputsV2/Checkbox.vue'
import { EZuntaInvoiceType, DateRange } from '@zunta/configurations'
import DateInput2 from '@/components/inputs/DateInput2.vue'
import ModalV2 from '@/components/modals/ModalV2.vue'
import InputDateRangePicker from '@/components/inputs/InputDateRangePicker.vue'
import { format, startOfMonth, subMonths } from 'date-fns'

@Component({
  components: {
    ModalV2,
    Checkbox,
    DateInput2,
    InputDateRangePicker,
  },
  props: {
    disabled: {
      type: Boolean,
      default: false
    }
  }
})
export default class CreateBatchModal extends Vue {
  batchDate: Date = new Date()
  invoiceTypes: EZuntaInvoiceType[] = [
    EZuntaInvoiceType.CC,
    EZuntaInvoiceType.ECHECK,
    EZuntaInvoiceType.MAILING,
    EZuntaInvoiceType.MONTHLY
  ]
  previousMonthStart = format(startOfMonth(subMonths(new Date(), 1)), 'MM/dd/yyyy')
  echeckBatchDateRangeBy1AMClose: DateRange<string> = { start: this.previousMonthStart, end: this.previousMonthStart }
  echeckBatchDateRangeBy8PMClose: DateRange<string> = { start: this.previousMonthStart, end: this.previousMonthStart }
  EZuntaInvoiceType: any = EZuntaInvoiceType

  emitCreate () {
    this.$emit('create', {
      invoiceTypes: this.invoiceTypes,
      batchDate: this.batchDate,
      echeckBatchCloseTimeOptions: this.isInvoiceTypeChecked(EZuntaInvoiceType.ECHECK) ? {
        '01:00': this.echeckBatchDateRangeBy1AMClose,
        '20:00': this.echeckBatchDateRangeBy8PMClose,
      } : null
    })
  }

  isInvoiceTypeChecked (type: EZuntaInvoiceType) {
    return this.invoiceTypes.includes(type)
  }

  toggleInvoiceType (event: any, type: EZuntaInvoiceType) {
    const index = this.invoiceTypes.findIndex((invoiceType: EZuntaInvoiceType) => invoiceType === type)
    if (index === -1) {
      this.invoiceTypes.push(type)
    } else {
      this.invoiceTypes.splice(index, 1)
    }
  }
}
